function displayInfo(field, falseDisplay="", trueDisplay=field) {
  if (field !== undefined) {
    return field ? trueDisplay : falseDisplay
  } else {
  return falseDisplay
  }
}

function hideUndefinedInfo(field, falseDisplay="", trueDisplay=field) {
  if (field !== undefined) {
    return field ? trueDisplay : falseDisplay
  } else {
  return null
  }
}

function limitLength(text, limit, mode) {
  if (text.length <= limit) {
    return text
  } else {
    return mode === "ellipsis" ? (text.slice(0, limit-3) + "...")
                               : (text.slice(0, limit))
  }
}


export { displayInfo, limitLength, hideUndefinedInfo }
